import { SearchCodes } from './SearchCodes';

export default SearchCodes;
